import THistoryList from './index.vue';

THistoryList.install = app => {
  app.component(THistoryList.name, THistoryList);
};

export default THistoryList;
